import { z } from 'zod';
export const projectsProjectReferenceCapability = 'projects.project-reference.v1';
export const projectsProjectReferenceAccessHoldCapability = 'projects.project-reference-access-hold.v1';
export const projectsProjectReferenceSnapshotSchema = z.strictObject({
    contractVersion: z.literal(projectsProjectReferenceCapability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
});
//# sourceMappingURL=projects-project-reference.contract.js.map